<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/reimbursement/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/reimbursement/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button><el-button plain v-if="$checkBtnPermission('/reimbursement/index', 'export')" size="small" type="warning" class="el-icon-download" @click="handleExport()" :loading="exportLoading">导出</el-button><el-button plain v-if="btnPermission.pay" size="small" type="success" class="el-icon-mouse" @click="handleBatchPay()">批量支付</el-button></template>
			<el-form-item label="报销单号：">
					<el-input v-model="formInline.code" placeholder="请输入报销单编号" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
			<el-form-item label="多门店分摊：">
				<el-select v-model="formInline.isAllocated" placeholder="全部" clearable size="small" @change="inputChange">
					<el-option label="分摊" :value="true"></el-option>
					<el-option label="不分摊" :value="false"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否审核：">
				<el-select v-model="formInline.isConfirm" placeholder="全部" clearable size="small" @change="inputChange">
					<el-option label="全部" :value="null"></el-option>
					<el-option label="已审核" :value="true"></el-option>
					<el-option label="未审核" :value="false"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否支付：">
				<el-select v-model="formInline.isPay" placeholder="全部" clearable size="small" @change="inputChange">
					<el-option label="全部" :value="null"></el-option>
					<el-option label="已支付" :value="true"></el-option>
					<el-option label="未支付" :value="false"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="报销人：">
					<el-select v-model="formInline.userKeyId" placeholder="请选择报销人" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="报销日期：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="报销内容：">
					<el-input v-model="formInline.content" placeholder="请输入报销内容" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId" @selection-change="handleSelectionChange" @get-data="getListData" @row-db-click="handleEdit">
				<template #isConfirm>
					<el-table-column align="center" label="是否审核" width="120">
						<template #default="scope">
							<el-tag v-if="scope.row.isConfirm" type="success">已审核</el-tag>
							<el-tag v-else type="danger">未审核</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #isPay>
					<el-table-column align="center" label="是否支付" width="120">
						<template #default="scope">
							<el-tag v-if="scope.row.isPay" type="success">已支付</el-tag>
							<el-tag v-else type="danger">未支付</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #isAllocated>
					<el-table-column align="center" label="分摊类型" width="120">
						<template #default="scope">
							<el-tag v-if="scope.row.isAllocated" type="warning">多门店</el-tag>
							<el-tag v-else>单门店</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #code>
					<el-table-column align="center" label="报销单号" min-width="220">
						<template #default="scope">
							<el-link type="primary" @click="handleViewDetail(scope.row)">{{ scope.row.code }}</el-link>
						</template>
					</el-table-column>
				</template>
			<template #operation>
				<el-table-column v-if="btnPermission.confirm || btnPermission.pay || btnPermission.delete" align="center" label="操作" width="210" fixed="right">
					<template #default="scope">
						<div class="lcsj-row-actions"><button class="lcsj-row-actions__link" v-if="scope.row.isConfirm == false && btnPermission.confirm" @click="handleConfirm(scope.row)">审核</button>
							<button class="lcsj-row-actions__link" v-else-if="scope.row.isPay == false && btnPermission.pay && scope.row.isConfirm == true" @click="handlePay(scope.row)">
							支付
							</button>
							<button class="lcsj-row-actions__link lcsj-row-actions__link--danger" v-if="!scope.row.isConfirm && !scope.row.isPay && btnPermission.delete" @click="handleDelete(scope.row)">删除</button>
						</div>
					</template>
				</el-table-column>
			</template>
			</STable>

			<Pagination :show-pager="pageShow" :child-msg="pageparm" @call-father="callFather">
				<template #summary>
				<div class="money-statistic">
					<span class="statistic-item total">
						报销总金额：
						<em v-money="moneyStatistic.totalMoney">￥{{ moneyStatistic.totalMoney }}元</em>
					</span>
					<span class="statistic-item confirmed">
						已审：
						<em v-money="moneyStatistic.confirmTotalMoney">￥{{ moneyStatistic.confirmTotalMoney }}元</em>
					</span>
					<span class="statistic-item unconfirmed">
						未审：
						<em v-money="moneyStatistic.unConfirmTotalMoney">￥{{ moneyStatistic.unConfirmTotalMoney }}元</em>
					</span>
					<span class="statistic-item finished">
						已完成：
						<em v-money="moneyStatistic.finishTotalMoney">￥{{ moneyStatistic.finishTotalMoney }}元</em>
					</span>
					<span class="statistic-item unfinished">
						未完成：
						<em v-money="moneyStatistic.unFinishTotalMoney">￥{{ moneyStatistic.unFinishTotalMoney }}元</em>
					</span>
				</div>
				</template>
			</Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 详情弹窗 -->
		<detailDialog ref="detailDialog"></detailDialog>
		<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetReimbursementPageList, ConfirmReimbursement, PayReimbursement, ExportReimbursement, DeleteReimbursement } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import edit from "./edit.vue";
import detailDialog from "./detailDialog.vue";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "报销记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			exportLoading: false, // 导出按钮 loading
			listData: [],
			selectRowKeyIds: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				content: "",
				code: "",
				userKeyId: "",
				startTime: null,
				endTime: null,
				isAllocated: null,
				isConfirm: null,
				isPay: null
			},
			storeList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center"
				},
				{
					slot: "isAllocated",
					label: "分摊类型",
					width: "120",
					align: "center"
				},
				{
					prop: "allocationStoreNames",
					label: "分摊门店",
					minWidth: "200",
					align: "center"
				},
				{
					prop: "allocationCount",
					label: "分摊门店数",
					width: "120",
					align: "center"
				},
				{
					prop: "costDate",
					label: "报销日期",
					isKeep: true,
					minWidth: "120",
					align: "center"
				},
				{
					slot: "code",
					label: "报销单号",
					isKeep: true,
					minWidth: "180",
					align: "center"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					width: "120",
					align: "center"
				},
				{
					slot: "isPay",
					label: "是否支付",
					width: "120",
					align: "center"
				},
				{
					prop: "content",
					label: "开支内容",
					minWidth: "200",
					align: "center"
				},
				{
					prop: "money",
					label: "金额",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "payUserTypeName",
					label: "支付方式",
					width: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "报销人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "填写时间",
					width: "170",
					align: "center"
				},
				{
					prop: "remark",
					label: "报销备注",
					width: "170",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					width: "120",
					align: "center"
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					width: "170",
					align: "center"
				},
				{
					prop: "payUserName",
					label: "支付人",
					width: "120",
					align: "center"
				},
				{
					prop: "payTime",
					label: "支付时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "170",
					align: "center"
				}
			],
			moneyStatistic: {
				totalMoney: 0,
				confirmTotalMoney: 0,
				finishTotalMoney: 0,
				unConfirmTotalMoney: 0,
				unFinishTotalMoney: 0
			},
			btnPermission: {
				confirm: false,
				pay: false,
				delete: false
			},
			userList: [],
			dateValue: [],
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	// 注册组件
	components: {
		edit,
		detailDialog,
		exportBlockDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetUserBindSelectByPermission();
		// 按钮权限
		this.btnPermission.confirm = this.$checkBtnPermission("/reimbursement/index", "confirm");
		this.btnPermission.pay = this.$checkBtnPermission("/reimbursement/index", "pay");
		this.btnPermission.delete = this.$checkBtnPermission("/reimbursement/index", "delete");
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 查看详情
		handleViewDetail(row) {
			this.$refs.detailDialog.getDetailDialog(row);
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.getListData();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null
			};
			GetReimbursementPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
						this.moneyStatistic = {
							totalMoney: res.totalMoney,
							confirmTotalMoney: res.confirmTotalMoney,
							finishTotalMoney: res.finishTotalMoney,
							unConfirmTotalMoney: res.unConfirmTotalMoney,
							unFinishTotalMoney: res.unFinishTotalMoney
						};
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 获取人员信息绑定下拉框_根据权限
		GetUserBindSelectByPermission() {
			const paramer = {};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.userList = [];
						if (res.code == 1) {
							this.userList = res.data;
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取人员信息失败!");
				});
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 确认
		handleConfirm(row) {
			ConfirmReimbursement({
				keyId: row.keyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "确认成功"
						});
						this.getListData();
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("确认失败，请稍后再试！");
				});
		},
		// 支付
		handlePay(row) {
			PayReimbursement({
				keyIds: [row.keyId]
			})
				.then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "支付成功"
						});
						this.getListData();
					} else {
						this.$message({
							type: "error",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("支付失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 表格勾选变化
		handleSelectionChange(val) {
			this.selectRowKeyIds = val.map((item) => item.keyId);
		},
		// 删除
		handleDelete(row) {
			if (row.isConfirm) {
				this.$message.error("报销记录已审核，不能删除！");
				return;
			}
			if (row.isPay) {
				this.$message.error("报销记录已支付，不能删除！");
				return;
			}
			this.$confirm("确定删除报销单【" + row.code + "】吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					DeleteReimbursement({ keyId: row.keyId })
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "删除成功"
								});
								this.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("删除失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		},
		// 批量支付
		handleBatchPay() {
			if (this.selectRowKeyIds.length == 0) {
				this.$message.error("请选择要支付的报销单！");
				return;
			}
			// 仅保留当前页已勾选的行
			const selectedRows = this.listData.filter((row) => this.selectRowKeyIds.includes(row.keyId));
			// 过滤出符合支付条件的行（已审核且未支付）
			const validRows = selectedRows.filter((row) => row.isConfirm && !row.isPay);
			if (validRows.length == 0) {
				this.$message.error("所选报销单均不符合支付条件（需已审核且未支付）！");
				return;
			}
			const skipCount = selectedRows.length - validRows.length;
			const tip = skipCount > 0 ? `其中 ${skipCount} 条不符合条件（未审核或已支付）将被跳过，确认支付其余 ${validRows.length} 条吗？` : `确认支付选中的 ${validRows.length} 条报销单吗？`;
			this.$confirm(tip, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					PayReimbursement({ keyIds: validRows.map((r) => r.keyId) })
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: res.msg || "支付成功"
								});
								this.getListData();
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.$message.error("支付失败，请稍后再试！");
						})
						.finally(() => {
							this.loading = false;
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消支付"
					});
				});
		},
		// 导出
		handleExport() {
			exportWithLoading(this, "exportLoading", () => ExportReimbursement(this.formInline), "导出失败，请稍后再试！");
		}
	}
};
</script>

<style scoped>
.money-statistic {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px 15px;
}
.statistic-item {
	display: flex;
	align-items: center;
	font-size: 14px;
}
.statistic-item em {
	font-style: normal;
	font-weight: bold;
}
.statistic-item.total {
	color: var(--app-primary);
}
.statistic-item.total em {
	color: var(--app-primary);
}
.statistic-item.confirmed {
	color: var(--app-success);
}
.statistic-item.confirmed em {
	color: var(--app-success);
}
.statistic-item.finished {
	color: var(--app-warning);
}
.statistic-item.finished em {
	color: var(--app-warning);
}
.statistic-item.unconfirmed {
	color: var(--app-danger);
}
.statistic-item.unconfirmed em {
	color: var(--app-danger);
}
.statistic-item.unfinished {
	color: var(--app-text-muted);
}
.statistic-item.unfinished em {
	color: var(--app-text-muted);
}
/* 行内操作文字链（由表格操作列改造脚本注入） */
.lcsj-row-actions {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	white-space: nowrap;
}

.lcsj-row-actions__link {
	color: var(--app-primary-text);
	cursor: pointer;
	font-size: var(--app-font-base);
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
	line-height: 1.6;
}

.lcsj-row-actions__link:hover {
	text-decoration: underline;
}

.lcsj-row-actions__link--danger {
	color: var(--app-danger-text);
}
</style>
